import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';
import numeral from 'numeral';

Vue.mixin({
  filters: {
    upperFirst(value: any) {
      return _.upperFirst(_.toLower(value));
    },
    timeFromNow: (value: any) =>
      moment
        .duration(moment().diff(moment(value)))
        .humanize({ d: 999, w: 999 }),
    date: (datetime: any) =>
      moment(datetime).tz(moment.tz.guess()).local().format('DD/MM/YYYY'),
    dateVerbose: (datetime: any) =>
      moment(datetime).tz(moment.tz.guess()).local().format('DD - MM - YYYY'),
    time: (datetime: any) =>
      moment(datetime).tz(moment.tz.guess()).local().format('HH:mm'),
    prettify: (value: any) => numeral(value).format('0,0'),
    capitalFirst: (value: any) => _.capitalize(value),
    lowercase: (value: any) => _.lowerCase(value),
    timeAgo: (value: any) => moment(value).fromNow(),
  },
  methods: {
    upperFirst(value) {
      return _.upperFirst(_.toLower(value));
    },
    timeFromNow: (value) =>
      moment
        .duration(moment().diff(moment(value)))
        .humanize({ d: 999, w: 999 }),
    date: (datetime) =>
      moment(datetime).tz(moment.tz.guess()).local().format('DD/MM/YYYY'),
    dateVerbose: (datetime) =>
      moment(datetime).tz(moment.tz.guess()).local().format('DD - MM - YYYY'),
    time: (datetime) =>
      moment(datetime).tz(moment.tz.guess()).local().format('HH:mm'),
    prettify: (value) => numeral(value).format('0,0'),
    capitalFirst: (value) => _.capitalize(value),
    lowercase: (value) => _.lowerCase(value),
    timeAgo: (value) => moment(value).fromNow(),
    formatDate: (value, type) =>
      value
        ? moment(value).format(type === 'month' ? 'MM-YYYY' : 'DD-MM-YYYY')
        : '',
    dateAndTimeFormat(value) {
      if (this.$i18n.locale === 'ja')
        return moment(value).format('YYYY/MM/DD HH:mm');
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    dateFormat(value) {
      if (this.$i18n.locale === 'ja') return moment(value).format('YYYY/MM/DD');
      return moment(value).format('DD/MM/YYYY');
    },
    callIf: (condition: boolean, fn: (...args: any[]) => any) =>
      condition ? fn() : null,
    convertLinkify: (html: string) => {
      const urlRegex =
        /(https?:\/\/[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*))(?!["']|.*<\/a>|<\/a>)/g;
      return html
        .replace(
          urlRegex,
          (url) => `<a href="${url}" target="_blank">${url}</a>`,
        )
        .replace(/\n/g, '</br>');
    },
  },
});
